<template>
    <ul :class="layoutClass">
        <li>
            <el-checkbox v-model="item.checked" @change="$emit('singleElection')"></el-checkbox>
        </li>
        <li class="main">
            <div style="display: flex;align-items: center; justify-content: space-between">
                <goods-info :item="item" tag="换购"></goods-info>
                <div class="cart-info" style="margin-right: 15%">
                    <el-popover
                        placement="top"
                        width="800"
                        trigger="click">
                        <div class="getfree-wrapper">
                            <div class="row header">
                                <div class="goods">商品信息</div>
                                <div class="item">换购价格</div>
                                <div class="item">数量</div>
                                <div class="item">小计</div>
                            </div>
                            <div class="row" v-for="(free_item, index) in item.get_free_goods.getFreeGoods">
                                <div class="goods">
                                    <goods-info :item="freeGoodsInfoAdpter(free_item)"></goods-info>
                                </div>
                                <div class="item">￥{{ free_item.price }}</div>
                                <div class="item">{{ computeFreeGoodsNum(free_item) }}</div>
                                <div class="item" style="color: #ec4944">
                                    ￥{{ (computeFreeGoodsNum(free_item) * free_item.price).toFixed(2) }}
                                </div>
                            </div>
                            <div v-if="!item.get_free_goods.getFreeGoods.length" class="empty"
                                 style="text-align: center;padding: 15px 0">暂无换购商品
                            </div>
                        </div>
                        <el-button slot="reference" type="text">换购信息</el-button>
                    </el-popover>
                </div>
            </div>
        </li>
        <li class="mini-li" v-if="layoutClass === 'mini'">
            <span>￥{{  item.discount_price }} x {{item.num}}</span>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>
        <li>
            <span>￥{{ item.discount_price }}</span>
        </li>
        <li>
            <el-input-number v-model="item.num" :step="item.min_buy || 1" size="mini" :min="item.min_buy || 1"
                             :max="item.stock" @change="cartNumChange"></el-input-number>
        </li>
        <li><strong class="subtotal ns-text-color">￥{{ calculationOfPrice(item) }}</strong></li>
        <li>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>

    </ul>
</template>
<script>
    import CartItemMixin from "@/views/goods/cart/common/cart-item-mixin"

    export default {
        name: "default-cart-item",
        mixins: [CartItemMixin],
        methods: {
            freeGoodsInfoAdpter(item) {
                return {
                    ...item,
                    sku_name: item.goods.goods_name,
                    sku_image: item.goods.goods_image,
                    sku_id: item.goods.sku_id
                }
            },

            computeFreeGoodsNum(free_item) {
                if (this.item.num < free_item.count) return 0
                const num = Math.floor(this.item.num / free_item.count)
                if (num >= free_item.limit) return free_item.limit
                return num
            }
        },
        computed: {
            calculationOfPrice() {
                return (item) => {
                    let { num, goods_limit, price, discount_price } = item
                    let withinLimit = Math.min(num, goods_limit)
                    let overLimit = Math.max(num - goods_limit, 0)
                    let totalPrice = withinLimit * discount_price + overLimit * price
                    this.item.subtotal = totalPrice.toFixed(2)
                    // 先判断是否超出限购数量 goods_limit
                    return this.item.subtotal
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../common/list.scss';

    .getfree-wrapper {
        .header {
            background: #f1f4f6;
            margin-bottom: 10px;

            .goods {
                text-align: center;
            }
        }

        .row {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px 0;
            border-bottom: 1px solid #f1f4f6;

            .goods {
                flex: 1;
            }

            .item {
                width: 100px;
                text-align: center;
            }

            &:last-of-type {
                border-bottom: none;
            }
        }
    }
</style>
